import routes from './routes';

export default routes;
export * from './routes';
